const Hero = () => {
	return (
		<section className="pt-36 pb-24 hero-bg">
			<div className="container">
				<div className="text-center max-w-2xl mx-auto">
					<h2 className="md:text-5xl/tight text-3xl font-semibold mb-5">
						How We Use Your Information
					</h2>
					<p className="md:text-lg text-slate-500 leading-7">
						We may share your information with third parties who perform services 
						on our behalf, such as payment processors or hosting providers
					</p>
				</div>
			</div>
		</section>
	)
}

export default Hero
